<template lang="pug">
.results-list.mt-4
  v-data-table(
    :headers="headers"
    :items="computedList"
    v-model="activeItems"
    item-key="id"
    hide-default-footer
    :disable-sort="true"
    :server-items-length="list.length"
    :loading="loading"
    hide-default-header=true
    class="table table_chess"
  )
    template(v-slot:header="{props, on }")
      tr
        th(v-for="(header, index) in props.headers" :key="index" :align="header.align" :class="header.class") {{ header.text}}
    template(v-slot:item="{item, select, isSelected, index}")
      list-item(:item="item" :cities="cities" :key="'i' + item.id" :dates="dates")

      list-item(:item="totalAvailability" :dates="dates" v-if="index === list.length - 1")
      
</template>
<script>
import { CBR_ACC } from '../core/models/CbrAccModel'
import { ComputedAvailability } from '../core/models/CbrAvailabalityModel'
export default {
  props: {
    list: {
      type: Array,
      required: true
    },
    headers: {
      type: Array,
      required: true
    },
    dates: Array,
    loading: Boolean,
    cities: Array
  },

  data: () => ({
    activeItems: [],

  }),

  computed: {
    computedList() {
      return this.list.map(item => new ComputedAvailability(item).execute())
    },
    totalReservedStudents() {
      return this.list.reduce((a, b) => a + b.currently_reserved_students, 0)
    },
    totalMaxReservedStudents() {
      return this.list.reduce((a, b) => a + b.max_reserved_students, 0)
    },
    totalDatesChanges() {
      return this.list.reduce((a, b) => {
        let changes = {...a.changes}
        Object.keys(b.changes).map(date => {
          if(date in changes) {
            changes[date] += b.changes[date]
          }
          else changes[date] = b.changes[date]
        })
        return {changes}
      })
    },

    totalAvailability() {
      return new ComputedAvailability({
        username: 'total',
        max_reserved_students: this.totalMaxReservedStudents,
        currently_reserved_students: this.totalReservedStudents,
        ...this.totalDatesChanges,
        
      }).execute()
    }
  },

  methods: {
    toggleSelectAll(on, props) {
      return on['toggle-select-all'](!props.everyItem)
    },

    importSelected() {
      this.$emit('importClicked', this.activeItems)
    },

    getDateTotalValue(date) {
      let count = 0, change = 0;
      this.computedList.forEach( item => {
        if( item.changes[date] ) {
          count += item.changes[date].count;
          change += item.changes[date].change;
        }
      } );
      return (count || change) ? `${count} (+${change})` : '-';
    }
  },

  components: {
    listItem: () => import ('./CbrAvailabilityItem.vue')
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/tableMain.scss";
</style>
